import{m as o}from"./chunk-HBP5N4FR.js";o();var e=`.dapp-core-component__tokenSymbol__token-symbol,
.dapp-core-component__tokenSymbol__token-symbol-combined {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 50%;
}
.dapp-core-component__tokenSymbol__token-symbol svg #dapp-core-component__tokenSymbol__egld-token,
.dapp-core-component__tokenSymbol__token-symbol-combined svg #dapp-core-component__tokenSymbol__egld-token {
  fill: #000;
}

.dapp-core-component__tokenSymbol__token-symbol-combined {
  background-color: rgba(0, 0, 0, 0);
}

.dapp-core-component__tokenSymbol__token-symbol {
  border: 1px solid #000;
  width: 2rem;
  height: 2rem;
}
.dapp-core-component__tokenSymbol__token-symbol img {
  width: 100%;
  height: 100%;
}
.dapp-core-component__tokenSymbol__token-symbol svg {
  width: 1.25rem;
  height: 1.25rem;
}
.dapp-core-component__tokenSymbol__token-symbol svg.dapp-core-component__tokenSymbol__expanded {
  width: 100% !important;
  height: 100% !important;
}

.dapp-core-component__tokenSymbol__token-symbol-combined {
  width: 4.5rem;
  height: 4.5rem;
}
.dapp-core-component__tokenSymbol__token-symbol-combined svg circle {
  fill: #fff;
}
.dapp-core-component__tokenSymbol__token-symbol-combined svg {
  width: 4.25rem;
  height: 4.25rem;
}
.dapp-core-component__tokenSymbol__token-symbol-combined.dapp-core-component__tokenSymbol__small {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
}
.dapp-core-component__tokenSymbol__token-symbol-combined.dapp-core-component__tokenSymbol__small svg {
  width: 2.5rem;
  height: 2.5rem;
}

.dapp-core-component__tokenSymbol__token-icon-lg .dapp-core-component__tokenSymbol__token-symbol {
  width: 3rem;
  height: 3rem;
}
.dapp-core-component__tokenSymbol__token-icon-lg .dapp-core-component__tokenSymbol__token-symbol svg {
  width: 2.25rem;
  height: 2.25rem;
}

.dapp-core-component__tokenSymbol__token-icon-xl .dapp-core-component__tokenSymbol__token-symbol {
  width: 4rem;
  height: 4rem;
}
.dapp-core-component__tokenSymbol__token-icon-xl .dapp-core-component__tokenSymbol__token-symbol svg {
  width: 2.3rem;
  height: 2.3rem;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(e));var m={"token-symbol":"dapp-core-component__tokenSymbol__token-symbol",tokenSymbol:"dapp-core-component__tokenSymbol__token-symbol","token-symbol-combined":"dapp-core-component__tokenSymbol__token-symbol-combined",tokenSymbolCombined:"dapp-core-component__tokenSymbol__token-symbol-combined","egld-token":"dapp-core-component__tokenSymbol__egld-token",egldToken:"dapp-core-component__tokenSymbol__egld-token",expanded:"dapp-core-component__tokenSymbol__expanded",small:"dapp-core-component__tokenSymbol__small","token-icon-lg":"dapp-core-component__tokenSymbol__token-icon-lg",tokenIconLg:"dapp-core-component__tokenSymbol__token-icon-lg","token-icon-xl":"dapp-core-component__tokenSymbol__token-icon-xl",tokenIconXl:"dapp-core-component__tokenSymbol__token-icon-xl"};export{e as a,m as b};
//# sourceMappingURL=chunk-RIFX2ADT.js.map
